export const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

export const motionTransition = {
  duration: 0.8,
  ease: [0.22, 1, 0.36, 1] as const,
};

export const staggerChildren = (stagger = 0.12) => ({
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: stagger } },
});

export default {
  fadeUp,
  motionTransition,
  staggerChildren,
};
